var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useAppSelector } from "@/hooks/store";
import { useGetModuleListQuery, useSaveDashletPreferencesMutation, } from "@/store/api";
import { getCurrentUser } from "@/store/utils/selectors/userSelector";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Grid from "@toast-ui/react-grid";
import TuiGrid from "tui-grid";
import { tableOptions } from "../..";
import { createRoot } from "react-dom/client";
import { debounce } from "lodash";
import { Provider } from "react-redux";
import store from "@/store";
import DisplayField from "@/components/fields/displayField";
import { FieldViewType } from "@/components/fields/viewType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faRotateLeft } from "@fortawesome/pro-regular-svg-icons";
import { faClose } from "@fortawesome/pro-solid-svg-icons";
import { Pagination } from "@/components/dev/pagination";
import { LoaderImage } from "@/utils/loader";
import { useNavigate } from "react-router-dom";
import { DashletContext } from "../dashboard";
/**
 * <b>Composants de rendu de dashlet liste</b>
 *
 * @param param0
 */
function GenericDashlet(_a) {
    var _this = this;
    var widget = _a.widget;
    var currentUser = useAppSelector(getCurrentUser) || {};
    var gridRef = useRef(null);
    var _b = useState(400), cwidth = _b[0], setclientWidth = _b[1];
    useEffect(function () {
        var width = (gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) && (gridRef === null || gridRef === void 0 ? void 0 : gridRef.current.clientWidth);
        setclientWidth(width);
    }, [widget]);
    var t = useTranslation([
        "common",
        "Administration",
        "Home",
        widget === null || widget === void 0 ? void 0 : widget.payload.module,
    ]).t;
    // Get Dashlet Context
    var _c = useContext(DashletContext), settings = _c.settings, editedSettings = _c.editedSettings;
    var _d = useState([]), records = _d[0], setRecords = _d[1];
    var _e = useState([]), tuiRecord = _e[0], setTuiRecord = _e[1];
    var _f = useState(5), pageSize = _f[0], setPageSize = _f[1];
    var _g = useState(400), widthValue = _g[0], setwValue = _g[1];
    var navigate = useNavigate();
    var _h = useState([
        {
            name: "date_modified",
            direction: "descending",
        },
    ]), sortedParams = _h[0], setSortedParams = _h[1];
    var _j = useState(0), currentPage = _j[0], setCurrentPage = _j[1];
    var tuiref = useRef(null);
    var module = widget === null || widget === void 0 ? void 0 : widget.payload.module;
    var titleTR = t("app.LBL_MY", { ns: "common" }) +
        " " +
        t("LBL_MODULE_NAME", {
            ns: module,
        });
    var title = (widget === null || widget === void 0 ? void 0 : widget.payload.title) || titleTR;
    //const cwidth = widget?.payload.cwidth;
    var view_defs = (widget === null || widget === void 0 ? void 0 : widget.payload.view_defs) || [];
    var field_defs = (widget === null || widget === void 0 ? void 0 : widget.payload.field_defs) || [];
    var displayRows = (widget === null || widget === void 0 ? void 0 : widget.payload.displayRows) || 3;
    var refreshValue = (widget === null || widget === void 0 ? void 0 : widget.payload.refresh) || -1;
    var myItems = widget === null || widget === void 0 ? void 0 : widget.payload.myItems;
    var filters = (widget === null || widget === void 0 ? void 0 : widget.payload.filters) || [];
    var id = (widget === null || widget === void 0 ? void 0 : widget.payload.id) || "";
    var allDashlets = (widget === null || widget === void 0 ? void 0 : widget.payload.allDashlets) || [];
    var defaultRules = [
        {
            field: "assigned_user_id",
            operator: "eq",
            value: typeof currentUser === "string" ? currentUser : currentUser.id,
        },
    ];
    var _k = useState(defaultRules), rules = _k[0], setRules = _k[1];
    var filterToArray = function (filters) {
        var allfilters = [];
        filters &&
            filters.map(function (item) {
                allfilters.push(item.filters);
            });
        return allfilters;
    };
    var whereRule = [
        {
            operator: "and",
            rules: rules,
        },
    ];
    useEffect(function () {
        if (!myItems && filters.length === 0) {
            var filterRules = [
                {
                    field: "deleted",
                    operator: "eq",
                    value: 0,
                },
            ];
            setRules(filterRules);
        }
        else if (filters.length > 0 && !myItems) {
            var filterRules = __spreadArray([
                {
                    field: "deleted",
                    operator: "eq",
                    value: 0,
                }
            ], filterToArray((settings === null || settings === void 0 ? void 0 : settings.dashlet.filters) || filters), true);
            setRules(filterRules);
        }
        else if (filters.length > 0 && myItems) {
            var filterRules = __spreadArray(__spreadArray([], defaultRules, true), filterToArray((settings === null || settings === void 0 ? void 0 : settings.dashlet.filters) || filters), true);
            setRules(filterRules);
        }
        else if (filters.length === 0 && myItems) {
            setRules(defaultRules);
        }
    }, [filters, myItems]);
    var _l = useState(false), skiped = _l[0], setSkiped = _l[1];
    // Get result
    var _m = useGetModuleListQuery({
        table: module,
        params: {
            sorted: sortedParams,
            where: whereRule,
            page: currentPage,
            pageSize: displayRows || pageSize,
            count: false,
        },
        skip: { skiped: skiped },
    }), recordResponse = _m.data, isLoading = _m.isLoading, isSuccess = _m.isSuccess, refetch = _m.refetch;
    // Count result
    var recordCount = useGetModuleListQuery({
        table: module,
        params: {
            where: whereRule,
            page: 0,
            pageSize: -1,
            count_only: true,
        },
    }).data;
    var _o = useState(0), totalRecord = _o[0], setTotalRecord = _o[1];
    useMemo(function () {
        var _a;
        // Grid data
        var totalRecord = ((_a = recordCount === null || recordCount === void 0 ? void 0 : recordCount.data) === null || _a === void 0 ? void 0 : _a.total_count) || 0;
        setTotalRecord(totalRecord);
    }, [recordCount]);
    // Grid columns
    var _p = useState([]), columns = _p[0], setColumns = _p[1];
    useEffect(function () {
        var cols = [];
        view_defs &&
            (view_defs === null || view_defs === void 0 ? void 0 : view_defs.forEach(function (item) {
                cols.push({
                    header: t(item.label ? item.label : field_defs[item.name].vname, {
                        ns: module || "common",
                    }),
                    name: item.name,
                });
            }));
        cols.push({
            header: "",
            name: "edit",
        });
        setColumns(cols);
    }, [view_defs, t]);
    TuiGrid.applyTheme("default", tableOptions);
    // Ajout bouton éditer
    var EditButtonRenderer = /** @class */ (function () {
        function EditButtonRenderer(props) {
            this.el = document.createElement("div");
            this.root = createRoot(this.el);
            this.render(props);
        }
        EditButtonRenderer.prototype.getElement = function () {
            return this.el;
        };
        EditButtonRenderer.prototype.render = function (props) {
            var _this = this;
            var handleClick = function () { return __awaiter(_this, void 0, void 0, function () {
                var rowKey, link_moduleName;
                var _a, _b;
                return __generator(this, function (_c) {
                    rowKey = props.rowKey;
                    link_moduleName = (_a = records.find(function (obj) { var _a; return obj.id === ((_a = records[rowKey]) === null || _a === void 0 ? void 0 : _a.id); })) === null || _a === void 0 ? void 0 : _a.module_name;
                    if (link_moduleName) {
                        navigate("/modules/".concat(link_moduleName, "/EditView/").concat((_b = records[rowKey]) === null || _b === void 0 ? void 0 : _b.id));
                    }
                    return [2 /*return*/];
                });
            }); };
            var buttonEdit = function () {
                return (_jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: handleClick, title: String(t("app.LBL_EDIT_BUTTON", { ns: "common" })) }, { children: _jsx(FontAwesomeIcon, { icon: faPen, className: "text-gray-400 pl-2" }) })));
            };
            this.root.render(buttonEdit());
        };
        return EditButtonRenderer;
    }());
    // Custom header
    //const sort = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort" class="svg-inline--fa fa-sort text-gray-200 cursor-auto" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"></path></svg>`;
    var GetHeaderClass = /** @class */ (function () {
        function GetHeaderClass(props) {
            var columnInfo = props.columnInfo || {};
            var el = document.createElement("div");
            el.style.cssText =
                "display: flex;flex-direction: row;justify-content: space-between;padding-left: 8px;padding-right: 8px;";
            el.className = "column-header column-header-".concat(props.columnInfo.column);
            el.title = "".concat(columnInfo.header);
            var text = el.appendChild(document.createElement("span"));
            text.style.cssText =
                "overflow: hidden;text-overflow: ellipsis;white-space: nowrap;";
            text.textContent = "".concat(columnInfo.header);
            /*if (props.columnInfo.sortable) {
              const link = el.appendChild(document.createElement("button"));
              link.className = "sort-icon";
      
              link.innerHTML = sort;
            }*/
            this.el = el;
        }
        GetHeaderClass.prototype.getElement = function () {
            return this.el;
        };
        GetHeaderClass.prototype.render = function (props) { };
        return GetHeaderClass;
    }());
    var complexColumnPrefix = "complex_";
    useEffect(function () {
        // Complex columns
        var header = {
            complexColumns: [],
        };
        columns.forEach(function (c) {
            // TODO: requete php à modifier pour le tri côté serveur pour les champs de type email et parent
            //if (c.name !== "email1" && c.name !== "parent_name") {
            var columnName = "".concat(complexColumnPrefix).concat(c.name);
            var f = field_defs || {};
            var fd = f[c.name] || "";
            var isSortable = fd.sortable !== undefined ? fd.sortable : true;
            header.complexColumns.push({
                header: c.header,
                name: columnName,
                childNames: [c.name],
                headerAlign: "center",
                headerVAlign: "middle",
                headerRenderer: GetHeaderClass,
                resizable: true,
                hideChildHeaders: true,
                sortOrder: "desc",
                sortable: isSortable,
            });
            //}
        });
        tuiref.current && (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current.gridInst.setHeader(header));
        // Calcul width
        tuiref.current &&
            (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current.gridInst.setWidth((cwidth * 100) / 100 - 32));
    }, [tuiref.current && (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current), columns, records]);
    // Custom render
    var CellRendererClass = /** @class */ (function () {
        function CellRendererClass(props) {
            var _this = this;
            var rootDom = document.createElement("div");
            rootDom.style.overflow = "hidden";
            this.el = rootDom;
            this.root = createRoot(this.el);
            this.debouncedRender = debounce(function (props) {
                var element = (_jsx(Provider, __assign({ store: store }, { children: _jsx(DisplayField, { record: records[props.rowKey] || {}, moduleName: module, fieldName: props.columnInfo.name, viewType: FieldViewType.LIST, fieldLabel: props.columnInfo.header, fieldMetadata: field_defs[props.columnInfo.name], hideLabel: true, className: "px-2", labelClassName: "font-medium", isOnStudio: false, fieldDef: field_defs[props.columnInfo.name] &&
                            field_defs[props.columnInfo.name].type === "varchar" &&
                            field_defs[props.columnInfo.name].group &&
                            field_defs[props.columnInfo.name].group !== "email1"
                            ? field_defs
                            : {} }) })));
                _this.root.render(element);
            }, 100);
            this.render(props);
        }
        CellRendererClass.prototype.getElement = function () {
            return this.el;
        };
        CellRendererClass.prototype.render = function (props) {
            if (typeof this.debouncedRender === "function") {
                this.debouncedRender(props);
            }
            else {
                console.error("debouncedRender is not a function");
            }
        };
        return CellRendererClass;
    }());
    var _q = useState(columns), tuiCols = _q[0], setTuiCols = _q[1];
    useEffect(function () {
        var cols = [];
        columns.forEach(function (row) {
            if (row.name === "edit") {
                cols.push({
                    name: row.name,
                    header: row.header,
                    width: 6,
                    sortable: false,
                    renderer: EditButtonRenderer,
                });
            }
            else {
                cols.push({
                    name: row.name,
                    header: row.header,
                    sortable: true,
                    sortingType: "desc",
                    renderer: CellRendererClass,
                });
            }
        });
        setTuiCols(cols);
    }, [columns, records]);
    // Event to change pagination
    var handlePagination = function (e) {
        var newPage = e.selected;
        if (newPage !== currentPage) {
            setCurrentPage(e.selected);
        }
    };
    var handleClick = function () {
        editedSettings(__assign(__assign({}, settings), { isSelected: true, module: module, id: id, title: title, dashlet: widget.payload }));
    };
    var _r = useSaveDashletPreferencesMutation(), saveDashletPreferences = _r[0], _s = _r[1], dashletLoad = _s.isLoading, isError = _s.isError, data = _s.data;
    var _t = useState(false), isNew = _t[0], setIsNew = _t[1];
    var removeClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var currentDashlet, newDashlets, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentDashlet = Object.values(widget === null || widget === void 0 ? void 0 : widget.rowMeta).filter(function (item) {
                        return item.id !== id;
                    });
                    newDashlets = Object.values(allDashlets).map(function (row) {
                        if (row.id === widget.rowId) {
                            return __assign(__assign({}, row), { meta: currentDashlet });
                        }
                        else {
                            return row;
                        }
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!window.confirm(String(t("LBL_REMOVE_DASHLET_CONFIRM", { ns: "Home" })))) return [3 /*break*/, 3];
                    return [4 /*yield*/, saveDashletPreferences({
                            dashlets: newDashlets,
                            isNew: isNew,
                        }).unwrap()];
                case 2:
                    result = _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error("Failed to save widgets:", error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (refreshValue && refreshValue !== -1) {
            var interval_1 = setInterval(function () {
                refetch();
                setCurrentPage(0);
                !skiped && setSkiped(true);
            }, parseInt(refreshValue) * 10000);
            return function () { return clearInterval(interval_1); };
        }
    }, [recordResponse]);
    useEffect(function () {
        var _a;
        var recordData = ((_a = recordResponse === null || recordResponse === void 0 ? void 0 : recordResponse.data) === null || _a === void 0 ? void 0 : _a.records) || [];
        var headerList = view_defs === null || view_defs === void 0 ? void 0 : view_defs.map(function (item) { return item.name; });
        var tuiRecordList = recordData.map(function (item) {
            var temp = {};
            headerList === null || headerList === void 0 ? void 0 : headerList.forEach(function (field) {
                temp[field] = item[field] === undefined ? "" : item[field];
            });
            return temp;
        });
        setRecords(recordData);
        setTuiRecord(tuiRecordList);
    }, [recordResponse, view_defs]);
    /*useEffect(() => {
      skiped && setSkiped(false);
    }, [recordResponse]);*/
    var _u = useState(false), upGrid = _u[0], setUpGrid = _u[1];
    useEffect(function () {
        setUpGrid(true);
    }, []);
    var allRecord = useMemo(function () {
        var _a;
        // Grid data
        var recordData = ((_a = recordResponse === null || recordResponse === void 0 ? void 0 : recordResponse.data) === null || _a === void 0 ? void 0 : _a.records) || [];
        var headerList = view_defs === null || view_defs === void 0 ? void 0 : view_defs.map(function (item) {
            return item.name;
        });
        var tuiRecordList = [];
        tuiRecordList =
            recordData &&
                (recordData === null || recordData === void 0 ? void 0 : recordData.map(function (item) {
                    var temp2 = [];
                    headerList === null || headerList === void 0 ? void 0 : headerList.forEach(function (field) {
                        var _a;
                        temp2 = __assign(__assign({}, temp2), (_a = {}, _a[field] = item[field] === undefined ? "" : item[field], _a));
                    });
                    return temp2;
                }));
        setRecords(recordData);
        setTuiRecord(tuiRecordList);
    }, [recordResponse]);
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ ref: gridRef, id: "grid", className: "m-2\n         dark:bg-[var(--colors-bg-default)] p-2 rounded-md shadow sm:p-4 relative grid-container" }, { children: [(isLoading || dashletLoad) && _jsx(LoaderImage, {}), _jsxs("div", __assign({ className: "border-b-2 mb-4 flex flex-row justify-between" }, { children: [_jsx("h3", __assign({ className: "uppercase font-bold my-2 overflow-hidden" }, { children: title })), _jsxs("div", __assign({ className: "flex flex-row justify-end" }, { children: [_jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: handleClick, title: String(t("app.LBL_EDIT_BUTTON", { ns: "common" })) }, { children: _jsx(FontAwesomeIcon, { icon: faPen, className: "text-gray-400" }) })), _jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: function () {
                                        setCurrentPage(0);
                                        setSkiped(true);
                                    }, title: String(t("LBL_RETURN", { ns: "Administration" })) }, { children: _jsx(FontAwesomeIcon, { icon: faRotateLeft, className: "text-gray-400" }) })), _jsx("button", __assign({ className: "hover:bg-red-500 p-1 rounded-md", onClick: removeClick, title: String(t("app.LBL_REMOVE", { ns: "common" })) }, { children: _jsx(FontAwesomeIcon, { icon: faClose, className: "text-gray-400 hover:text-white" }) }))] }))] })), _jsxs("div", __assign({ className: "flex-auto relative" }, { children: [records && upGrid && (_jsx(Grid, { ref: tuiref, width: "auto", columns: tuiCols, data: tuiRecord })), _jsx("div", __assign({ className: "justify-center absolute right-[70px] top-[-72px]" }, { children: _jsx("div", __assign({ className: "my-2" }, { children: _jsx(Pagination, { sizeClass: "smallSize", totalResult: totalRecord, elementPerPage: displayRows || pageSize, currentPage: currentPage, onChangePagination: function (event) { return handlePagination(event); } }) })) }))] }))] })) }));
}
widgetsDictionary.register("widget/dashlet/list", {
    name: "Widget de dashlet de type liste",
    display: GenericDashlet,
});
